import { render } from "./JudgeInfo.vue?vue&type=template&id=247c6732&scoped=true"
import script from "./JudgeInfo.vue?vue&type=script&lang=js"
export * from "./JudgeInfo.vue?vue&type=script&lang=js"

import "./JudgeInfo.vue?vue&type=style&index=0&id=247c6732&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-247c6732"]])

export default __exports__